module.exports = __webpack_public_path__ + "static/media/noimage.ec76d12d.svg";